var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-table-index-col"},[_c('div',{staticClass:"user-table-index-col--number"},[_vm._v(_vm._s(_vm.recordNumber))]),_vm._v(" "),_c('avatar',{attrs:{"upic":_vm.row.getUpic(),"name":_vm.row.getLastName(),"size":"ic"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }